import { render, staticRenderFns } from "./CollectionImageUpdate.vue?vue&type=template&id=902e3262&"
import script from "./CollectionImageUpdate.vue?vue&type=script&lang=js&"
export * from "./CollectionImageUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports